import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, ResponseResult } from 'vnpost-shared';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CalculateUnitService extends BaseService {
  constructor(http: HttpClient, injector: Injector) {
    super(http, injector, `${environment.apiDomain.llbJavaEndpoint}/measurementUnit`);
  }
  // token = 'YmUwYTk4MjUxNGE3NWEwYTliYjhjZDFkZGVhMGFhNzQ3ZTg1YzlhZjM1MmMwMmNjYjRmYTRiNzYzNzEyMGNhYw'; // Replace with your token

   
  // getListCalculateUnit(model): Promise<any> {
  //   const headers = new HttpHeaders({
  //     'Authorization': `Bearer ${this.token}`
  //   });
  //   let apiUrl = `${this.serviceUri}?with_count=true&page=${model.page}&limit=${model.limit}`;
  //   if (model.search) apiUrl += `&search=${model.search}`
  //   return this._http.get<any>(apiUrl, { headers })
  //     .pipe(catchError((err) => this.handleError(err, this._injector)))
  //     .toPromise();
  // }
   getListCalculateUnit(model): Promise<any> {
    const apiUrl = `${this.serviceUri}/getAll?search=${model?.code ?? ''}&pageNo=${model?.pageNo ?? ''}&pageSize=${model?.pageSize ?? ''}`;
    return this._http.get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  getCalculateUnitDetail(id: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/detail/${id}`;
    return this._http.get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  create(model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/create`;
    return this._http.post<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  update(id: any, model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/update/${id}`;
    return this._http.put<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  inactive(id: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/inActive/${id}`;
    return this._http.put<any>(apiUrl, {})
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
}
